'use client';

import { createContext, useContext } from 'react';

type ReviewSummaryContextType = {
  isLoading: boolean;
  hideReviewSummary: boolean | undefined;
  reviewSummary: string | undefined;
  onToggleHideReviewSummary: () => void;
};

const ReviewSummaryContext = createContext<ReviewSummaryContextType | null>(null);

export const useReviewSummaryContext = () => {
  const context = useContext(ReviewSummaryContext);
  if (!context) {
    throw new Error('useReviewSummaryContext must be used within a ReviewSummaryProvider');
  }
  return context;
};

export default ReviewSummaryContext;
